var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3600pt",
    height: "3600pt",
    viewBox: "0 0 3600 3600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1372.3 2163.1c-45.879 45.723-110.65 41.926-152.72-0.003907-42.07-41.93-45.883-106.49-0.003906-152.21l103.31-103.27h-458.92c-59.648 0-107.99-48.184-107.99-107.63 0-59.461 48.332-107.63 107.99-107.63l459 0.54688-103.39-103.83c-45.879-45.723-42.066-110.28 0.003906-152.21 42.07-41.93 106.84-45.73 152.81 0.089844l290.62 291.78c38.426 38.578 38.684 101.12 0.44531 139.8zm855.37-726.23c45.879-45.723 110.65-41.926 152.72 0.003907 42.07 41.93 45.883 106.49 0.003906 152.21l-103.31 103.27h458.92c59.648 0 107.99 48.184 107.99 107.63 0 59.461-48.332 107.63-107.99 107.63l-459-0.54688 103.39 103.83c45.879 45.723 42.066 110.28-0.003906 152.21-42.07 41.93-106.84 45.73-152.81-0.089844l-290.62-291.78c-38.426-38.578-38.684-101.12-0.44531-139.8z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.42c2a0b0868ca12c7f37a86e0813aceb.svg";
export { ForwardRef as ReactComponent };